let routes = [
  {
    path: '/demande-inscription-psychologue',
    component: () => import('../views/DemandeInscriptionPsychologue.vue'),
    props: true
  },
  {
    path: '/demande-inscription-psychologue/:step',
    component: () => import('../views/DemandeInscriptionPsychologue.vue'),
    props: true
  }
]

export default routes;